import React from 'react';
import { Form, Row, Col, Button } from "antd";
import PropTypes from "prop-types";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import  { SCHEME_CONTROLS_FORM_FIELDS }  from "constants/form-fields";
import { MpaFormsFooter } from '../../modules/companies/modules/mpa-form-footer';


class SchemeControlForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);

    onSave = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if(!err){
                this.props.updateDetail(values)
            }
        }); 
    }

    onApprove = () => {
        this.props.form.validateFields((err, values) => {
            if(!err){
                this.props.approveDetails()
            }
        }); 
    }

    validateField2 = (rule, value, callback) => {
        const field1Value = this.props.form.getFieldValue('ticket_size_min');
        if (value && field1Value && value < field1Value) {
          callback('Max Ticket Size cannot be less than Min Ticket Size');
        } else {
          callback();
        }
      };

    render() {
        return (
            <div className={"d-flex flex-row justify-content-space-between flex-wrap w-100 form"}>
                <Form onSubmit={this.onSave}>
                    <Row>
                        {SCHEME_CONTROLS_FORM_FIELDS.map((field, fieldName) => {
                            field.disabled = this.props.disableFields;
                            if(fieldName == "ticket_size_max"){
                                field.rules =  [
                                    { required: true, message: 'Field is Required' },
                                    // {pattern: /^(100|[1-9]\d?)$/, message: "Please enter a number between 1 and 100"},

                                    {
                                        pattern: /^(?:\d*\.)?\d+$/,
                                        message: "Please enter a valid number"                        
                                    },
                                    { validator: this.validateField2 },
                                  ]
                            }
                            const value = this.props.values && this.props.values.get(fieldName);
                            return <Col span="8">{this.fieldGenerator(
                                fieldName,
                                { ...field, value },
                                this.getValidateStatus(fieldName)
                            )()}</Col>
                        }).toList()}
                    </Row>
                    <MpaFormsFooter 
                        disableFields={this.props.disableFields}
                        approveDisabled={this.props.approveDisabled}
                        onApprove={this.onApprove}
                    />
                </Form>

            </div>
        );
    }
}

SchemeControlForm.propTypes = {
    approveDetails: PropTypes.func,
    approveDisabled: PropTypes.bool,
    disableFields: PropTypes.bool
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
            values
                .map((value, key) => {
                    return Form.createFormField({
                        value
                    });
                }).toJS();
    },
    onValuesChange: (props, changedValues, values) => {
    }
})(SchemeControlForm);